<kendo-grid
	#grid
	[data]="gridView"
	[skip]="skip"
	[pageSize]="pageSize"
	[scrollable]="'virtual'"
	[rowHeight]="rowHeight"
	[height]="actualHeight"
	[navigatable]="navigatable"
	[selectable]="selectable"
	(selectionChange)="selectionChange($event)"
	(pageChange)="pageChange($event)"
	(keyup.enter)="onKeyUp($event)">
	<kendo-grid-column [field]="field">
		<ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
			<ng-container *ngTemplateOutlet="itemTemplate ? itemTemplate : defaultItemTemplate; context:{selected:dataItem===selectedItem,dataItem: dataItem, description: dataItem[field], rowIndex: rowIndex};"></ng-container>
		</ng-template>
	</kendo-grid-column>
</kendo-grid>

<ng-template
	#defaultItemTemplate
	let-dataItem="dataItem"
	let-description="description"
	let-rowIndex="rowIndex">
	<div class="vertical-list-scrollable-default-item" (click)="defaultItemClickHandler(dataItem.originalData)" (dblclick)="defaultItemDoubleClickHandler(dataItem.originalData)">{{description}}</div>
</ng-template>
